<!-- @format -->

<template>
	<template v-if="typeItem.type === 'time'">
		<el-time-picker v-model="value" :format="typeItem.format" />
	</template>

	<template v-else>
		<el-date-picker v-model="value" :type="typeItem.type" :format="typeItem.format" placeholder="请选择日期时间" />
	</template>
</template>

<script setup lang="ts">
	import dayjs from 'dayjs';
	import { timeTypeList } from '../config';

	interface Props {
		modelValue: Date | string | null;
		options: any;
	}
	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue ? dayjs(props.modelValue || new Date(), typeItem.value.format).format() : null;
		},
		set(val) {
			emit('update:modelValue', val ? dayjs(val).format(typeItem.value.format) : val);
		},
	});

	const typeItem = computed(() => timeTypeList.find((itm) => itm.format === props.options.timeType) || timeTypeList[0]);
</script>

<style scoped lang="scss"></style>
